import { inject, Injectable } from '@angular/core';
import { StorageService } from '../storage/storage';
import { Subject } from 'rxjs';
import { UserI } from '../../../views/shared/interfaces/user.interface';
import { DecodedTokenI } from '../../../views/shared/interfaces/decoded-token.interface';

@Injectable({
  providedIn: 'root',
})
export class Session {
  private readonly loggedInUser: Subject<UserI | null> = new Subject();
  private readonly storageService = inject(StorageService);

  constructor() {}

  addLoggedInUser(user: UserI) {
    this.loggedInUser.next(user);
  }

  getLoggedInUser$() {
    return this.loggedInUser.asObservable();
  }

  getDecodedToken(): DecodedTokenI {
    return JSON.parse(atob(this.storageService.accessToken?.split('.')[1]!));
  }
}
